import React, { useState, useEffect, useContext } from 'react';
import SocketContext from '../../../../../../../NewWebSocket/components/WebSocketAdapter';
import './LevelControl.css';

interface LevelControlProps {
  championId: string;
  currentLevel: number;
  maxLevel?: number; // Dynamic max level (18 default, 20 for Top lane)
  onLevelUpdate?: (level: number) => void;
}

const LevelControl: React.FC<LevelControlProps> = ({
  championId,
  currentLevel,
  maxLevel = 18,
  onLevelUpdate
}) => {
  const socket = useContext(SocketContext);
  const [level, setLevel] = useState(currentLevel);
  const MIN_LEVEL = 1;
  const MAX_LEVEL = maxLevel;
  
  // Update local state when prop changes
  useEffect(() => {
    setLevel(currentLevel);
  }, [currentLevel]);
  
  // Handler for directly setting level via input
  const handleLevelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLevel = parseInt(e.target.value, 10);
    if (!isNaN(newLevel)) {
      // Ensure level is within valid range
      const clampedLevel = Math.min(Math.max(newLevel, MIN_LEVEL), MAX_LEVEL);
      setLevel(clampedLevel);
    }
  };
  
  // Handler for applying level change to the champion
  const applyLevelChange = () => {
    console.log(`[LevelControl] Setting champion ${championId} level to ${level}`);
    
    // Use onLevelUpdate if available (static mode), otherwise use socket (WebSocket mode)
    if (onLevelUpdate) {
      onLevelUpdate(level);
    } else if (socket) {
      socket.emit('set-champion-level', {
        championId: championId,
        level: level
      });
    }
  };

  // Spinner button handlers
  const incrementLevel = () => {
    const newLevel = Math.min(level + 1, MAX_LEVEL);
    setLevel(newLevel);
  };

  const decrementLevel = () => {
    const newLevel = Math.max(level - 1, MIN_LEVEL);
    setLevel(newLevel);
  };

  return (
    <div className="level-control">
      <div className="level-control-container">
        <div className="level-input-row">
          <h4>Level</h4>
          <div className="level-input-container">
            <input
              type="number"
              min={MIN_LEVEL}
              max={MAX_LEVEL}
              value={level}
              onChange={handleLevelChange}
              className="level-input"
            />
            <div className="custom-spinner">
              <button className="spinner-button" onClick={incrementLevel}></button>
              <button className="spinner-button" onClick={decrementLevel}></button>
            </div>
          </div>
          
          <span className="level-range">/ {MAX_LEVEL}</span>
          
          <button 
            onClick={applyLevelChange}
            className="apply-button"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default LevelControl; 